import { useState, useEffect } from 'react'
import { get, ref, onValue, orderByKey, query } from "firebase/database";
import toast from 'react-hot-toast';

import { db } from '../../utils/firebaseApp.js';

import ModalForViewFile from '../../components/utils/ModalForViewFile.js';
import ViewFileAdmin from '../../components/ViewFileAdmin.js';
import ViewFileAdmin2 from '../../components/ViewFileAdmin2.js';

import PaginationAdmin from '../DataExtraction/ExtractionFolder/PaginationAdmin.js';

import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import ReactJson from 'react18-json-view';
import { DocumentTextIcon, GlobeAltIcon, CalendarIcon, CubeIcon, AdjustmentsHorizontalIcon, CodeBracketIcon, XMarkIcon } from '@heroicons/react/24/outline';

import { formatDate } from '../../utils/formatDates.js';
import classNames from '../../utils/classNames.js';

const statuses = {
    Complete: 'text-green-700 bg-green-50 ring-green-600/20',
    complete: 'text-green-700 bg-green-50 ring-green-600/20',
    finished: 'text-green-700 bg-green-50 ring-green-600/20',
    'In progress': 'text-gray-600 bg-gray-50 ring-gray-500/10',
    'in progress': 'text-gray-600 bg-gray-50 ring-gray-500/10',
    processing: 'text-gray-600 bg-gray-50 ring-gray-500/10',
    archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
    Archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
}

export default function ShowUserDetails({ userId, closeModal }) {
    // i need to call when entering this function to get the user details
    const [userDetails, setUserDetails] = useState({});
    const [extractionsList, setExtractionsList] = useState([]);

    const [selectedExtraction, setSelectedExtraction] = useState({});
    const [batchesList, setBatchesList] = useState([]);

    const [selectedBatch, setSelectedBatch] = useState({});
    const [files, setFiles] = useState([]);
    const [fields, setFields] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [noOfPages, setNoOfPages] = useState(10);
    const itemsPerPage = 10;


    const [currentBatchPage, setCurrentBatchPage] = useState(1);
    const itemsPerBatchPage = 10; // Number of batches per page
    const [noOfPagesBatch, setNoOfPagesBatch] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const maxCharactersForField = 75;
    const maxCharactersForFieldObject = 50;

    const [viewType, setViewType] = useState('extractions');
    const [viewMode, setViewMode] = useState('batches'); // 'batches' or 'files'
    const [allFiles, setAllFiles] = useState([]);
    const [isLoadingAllFiles, setIsLoadingAllFiles] = useState(false);

    // Batch ID filter states
    const [batchIdInput, setBatchIdInput] = useState('');
    const [selectedBatchIds, setSelectedBatchIds] = useState([]);

    const fetchUserDetails = async () => {
        const userDetailsRef = ref(db, 'userDetails/' + userId);
        get(userDetailsRef).then((snapshot) => {
            if (snapshot.exists()) {
                setUserDetails(snapshot.val());
            } else {
                console.log('No data available');
            }
        }).catch((error) => {
            console.error('Error fetching data:', error);
        });
    }

    const fetchExtractionsList = async () => {
        try {
            // Fetch all extractions
            const extractionsListRef = ref(db, 'extractions/' + userId);
            const extractionsSnapshot = await get(extractionsListRef);

            // Fetch all batches at once
            const batchesListRef = ref(db, 'batches/' + userId);
            const batchesSnapshot = await get(batchesListRef);

            if (!extractionsSnapshot.exists()) {
                console.log('No extractions available');
                setExtractionsList([]);
                return;
            }

            const extractionsData = extractionsSnapshot.val() || {};
            const batchesData = batchesSnapshot.exists() ? batchesSnapshot.val() : {};

            let tempExtractions = [];

            Object.keys(extractionsData).forEach((extractionId) => {
                let extraction = extractionsData[extractionId] || {};
                extraction.id = extractionId;

                // Attach batches from the fetched data
                const extractionBatches = batchesData[extractionId] || {};

                // Determine extraction status based on batches
                let extractionStatus = 'complete';
                Object.values(extractionBatches).forEach((batch) => {
                    if (batch.status === 'processing') {
                        extractionStatus = 'processing';
                    }
                });

                let newExtraction = {
                    name: extraction.name ?? 'undefined',
                    description: extraction.description ?? '',
                    status: extractionStatus,
                    language: extraction.language,
                    noOfBatches: Object.keys(extractionBatches).length,
                    noOfFields: extraction.fields ? Object.keys(extraction.fields).length : 0,
                    batches: extractionBatches,
                    fields: extraction.fields,
                    id: extraction.id,
                    createdAt: extraction.createdAt ?? Date.now(),
                };

                tempExtractions.push(newExtraction);
            });

            // Sort the extractions by creation date
            const sortedTempExtractions = tempExtractions.sort((a, b) => Number(b.createdAt) - Number(a.createdAt));
            setExtractionsList(sortedTempExtractions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchBatchesList = async (extractionId) => {
        setBatchesList([]); // Clear old data
        setIsLoading(true); // Optional loading state

        // Updated path: from 'extractions/' + userId + '/' + extractionId + '/batches'
        // to 'batches/' + userId + '/' + extractionId
        const batchesListRef = ref(db, 'batches/' + userId + '/' + extractionId);

        get(batchesListRef).then((snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                if (data != null) {
                    let tempBatches = [];

                    Object.keys(data).forEach(function (key) {
                        let batch = data[key];
                        batch.id = key;

                        let numberOfDocs = 0;
                        try {
                            numberOfDocs = batch.files ? batch.files.length : 0;
                        } catch (error) {
                            numberOfDocs = 0;
                        }

                        let newBatch = {
                            id: batch.id,
                            name: 'Batch ' + batch.id,
                            numberOfDocuments: numberOfDocs,
                            startDateTime: batch.startTime,
                            status: batch.status,
                        }

                        tempBatches.push(newBatch);
                    });

                    // Sort the batches
                    let sortedTempBatches = tempBatches.sort((a, b) => Number(b.startDateTime) - Number(a.startDateTime));

                    // Apply batch ID filter if any IDs are selected
                    if (selectedBatchIds.length > 0) {
                        sortedTempBatches = sortedTempBatches.filter(batch =>
                            selectedBatchIds.includes(batch.id)
                        );
                    }

                    // Calculate pagination details
                    let totalItems = sortedTempBatches.length;
                    let tempNoOfPages = Math.ceil(totalItems / itemsPerBatchPage);
                    setNoOfPagesBatch(tempNoOfPages);

                    // Ensure current page is valid
                    if (currentBatchPage > tempNoOfPages) {
                        setCurrentBatchPage(tempNoOfPages > 0 ? tempNoOfPages : 1);
                    }

                    // Paginate the batches for the current page
                    let start = (currentBatchPage - 1) * itemsPerBatchPage;
                    let end = start + itemsPerBatchPage;
                    let paginatedBatches = sortedTempBatches.slice(start, end);

                    setBatchesList(paginatedBatches);
                    setIsLoading(false); // Optional to hide loading state
                }
            } else {
                console.log('No data available');
                setBatchesList([]);
                setIsLoading(false);
            }
        }).catch((error) => {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        });
    }

    const [unsubscribeFilesListener, setUnsubscribeFilesListener] = useState(null);

    const loadFiles = (selBatch) => {
        setFiles([]);

        let queryPath = 'files/' + userId + '/' + selectedExtraction.id + '/' + selBatch.id;
        let itemsRef = ref(db, queryPath)

        let tempKey;
        let itemsQuery;

        console.log(selectedExtraction);
        console.log(selBatch);

        tempKey = selectedExtraction.batches[selBatch.id].files[(currentPage - 1) * itemsPerPage];
        itemsQuery = query(itemsRef, orderByKey());

        const unsubscribe = onValue(itemsQuery, (snapshot) => {
            const data = snapshot.val();
            let tempFiles = [];

            if (data) {
                console.log('data', data);

                Object.keys(data).forEach((key) => {
                    let file = data[key];
                    file.id = key;

                    let newFile = {
                        id: file.id,
                        name: file.name ?? 'undefined',
                        url: file.url,
                        status: file.status,
                        errorMessage: file.errorMessage,
                        result: file.result ?? {},
                    }

                    tempFiles.push(newFile);
                });
                setFiles(tempFiles);
            } else {
                setFiles([]);
                console.log('No data available');
            }
        });

        setUnsubscribeFilesListener(() => unsubscribe);
    }

    const nextBatchPage = () => {
        if (currentBatchPage < noOfPagesBatch) {
            setCurrentBatchPage(currentBatchPage + 1);
        }
    };

    const previousBatchPage = () => {
        if (currentBatchPage > 1) {
            setCurrentBatchPage(currentBatchPage - 1);
        }
    };

    const selectBatchPage = (pageNumber) => {
        if (currentBatchPage !== pageNumber) {
            setCurrentBatchPage(pageNumber);
        }
    };

    const changeView = (type) => {
        if (type === 'extractions') {
            setSelectedExtraction({});
            setBatchesList([]);
            setSelectedBatch({});
            setFields([]);
            setFiles([]);
            setSelectedBatchIds([]);
            setBatchIdInput('');
        }

        if (type === 'batches') {
            setSelectedBatch({});
            setFields([]);
            setFiles([]);
        }

        if (type === 'batch') {
            // do nothing
        }

        setViewType(type);
    }

    const changeViewType = ({ type, extractionId, batchId }) => {
        console.log(type);
        console.log(extractionId);
        console.log(batchId);

        if (type === 'batches') {
            setSelectedExtraction(extractionsList.find((extraction) => extraction.id === extractionId));
            fetchBatchesList(extractionId);
            setViewMode('batches'); // Reset to batches view when changing extraction
            setSelectedBatchIds([]); // Clear batch ID filters when changing extraction
            setBatchIdInput('');
        }

        if (type === 'batch') {
            setSelectedBatch(batchesList.find((batch) => batch.id === batchId));
            setFields(selectedExtraction.fields ?? []);
            setNoOfPages(Math.ceil(selectedExtraction.batches[batchId].files.length / itemsPerPage));

            const selBatchList = batchesList.find((batch) => batch.id === batchId);
            loadFiles(selBatchList);
        }

        setViewType(type);
    }

    useEffect(() => {
        if (viewType === 'batches' && selectedExtraction.id) {
            fetchBatchesList(selectedExtraction.id);
        }
    }, [currentBatchPage, selectedExtraction.id, viewType, selectedBatchIds]);

    useEffect(() => {
        fetchUserDetails();
        fetchExtractionsList();
    }, [userId]);

    const pages = [
        { name: 'Batches', type: 'batches' },
        { name: 'Batch', type: 'batch' },
    ];

    function formatExtractionsDate(dateString) {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(Number(dateString)).toLocaleDateString(undefined, options);
    }

    let numberOfCredits = userDetails.credits?.credits ?? 0;
    numberOfCredits = numberOfCredits / 10;
    numberOfCredits = numberOfCredits.toFixed(0);

    let emailAddress = userDetails.account?.emailAddress ?? '-';

    const [showFileBool, setShowFileBool] = useState(false);
    const [selectedFile, setSelectedFile] = useState({
        file_id: '',
        file_url: '',
        file_name: '',
        status: '',
        data: {},
    });

    const openFileResult = async (file) => {
        const currentIndex = allFiles.findIndex(f => f.id === file.id);

        setSelectedFile({
            file_id: file.id,
            file_url: file.url,
            file_name: file.name,
            status: file.status,
            data: file.result,
            currentIndex: currentIndex,
            batchId: file.batchId  // Add this line
        });

        setShowFileBool(true);
    }

    // Add these new state variables to the existing ones
    const [currentAllFilesPage, setCurrentAllFilesPage] = useState(1);
    const [noOfAllFilesPages, setNoOfAllFilesPages] = useState(1);
    const itemsPerAllFilesPage = 10;

    // Modify the fetchAllFiles function to handle pagination
    const fetchAllFiles = async () => {
        if (selectedExtraction.id) {
            setIsLoadingAllFiles(true);
            setAllFiles([]);

            try {
                // Get all batches for this extraction
                const batchesRef = ref(db, 'batches/' + userId + '/' + selectedExtraction.id);
                const batchesSnapshot = await get(batchesRef);

                if (batchesSnapshot.exists()) {
                    const batchesData = batchesSnapshot.val();
                    let allFilesArray = [];

                    // For each batch, fetch all files
                    for (const batchId in batchesData) {
                        const filesRef = ref(db, 'files/' + userId + '/' + selectedExtraction.id + '/' + batchId);
                        const filesSnapshot = await get(filesRef);

                        if (filesSnapshot.exists()) {
                            const filesData = filesSnapshot.val();

                            // Add each file to our array with batch information
                            Object.keys(filesData).forEach(fileId => {
                                const file = filesData[fileId];
                                allFilesArray.push({
                                    ...file,
                                    id: fileId,
                                    batchId: batchId,
                                    result: file.result ?? {},
                                });
                            });
                        }
                    }

                    // Sort files by name or timestamp if available
                    allFilesArray.sort((a, b) => {
                        if (a.name && b.name) return a.name.localeCompare(b.name);
                        return 0;
                    });

                    setAllFiles(allFilesArray);
                    setNoOfAllFilesPages(Math.ceil(allFilesArray.length / itemsPerAllFilesPage));
                }
            } catch (error) {
                console.error('Error fetching all files:', error);
                toast.error('Failed to load all files');
            }

            setIsLoadingAllFiles(false);
        }
    };

    // Add these pagination functions
    const nextAllFilesPage = () => {
        if (currentAllFilesPage < noOfAllFilesPages) {
            setCurrentAllFilesPage(currentAllFilesPage + 1);
        }
    };

    const previousAllFilesPage = () => {
        if (currentAllFilesPage > 1) {
            setCurrentAllFilesPage(currentAllFilesPage - 1);
        }
    };

    const selectAllFilesPage = (pageNumber) => {
        if (currentAllFilesPage !== pageNumber) {
            setCurrentAllFilesPage(pageNumber);
        }
    };

    const toggleViewMode = () => {
        if (viewMode === 'batches') {
            setViewMode('files');
            fetchAllFiles();
        } else {
            setViewMode('batches');
        }
    };

    // Batch ID filter functions
    const handleBatchIdInputKeyDown = (e) => {
        if (e.key === 'Enter' && batchIdInput.trim() !== '') {
            e.preventDefault();
            const trimmedId = batchIdInput.trim();
            if (!selectedBatchIds.includes(trimmedId)) {
                setSelectedBatchIds([...selectedBatchIds, trimmedId]);
            }
            setBatchIdInput('');
        }
    };

    const removeBatchIdFilter = (idToRemove) => {
        setSelectedBatchIds(selectedBatchIds.filter(id => id !== idToRemove));
    };

    const clearAllBatchIdFilters = () => {
        setSelectedBatchIds([]);
    };

    return (
        <div className='w-full h-full flex flex-col items-start p-14'>
            <p className='mb-3'>Details for user: {userId}</p>
            <p className='mb-3'>Email address: {emailAddress}</p>
            <p className='mb-3'>Pages: {numberOfCredits} pages</p>

            <ModalForViewFile open={showFileBool} setOpen={setShowFileBool}>
                {viewMode === 'files' ? (
                    // Use ViewFileAdmin2 for "View All Files" mode
                    <ViewFileAdmin2
                        closeModal={() => {
                            setShowFileBool(false);
                            setSelectedFile({
                                file_id: '',
                                file_url: '',
                                file_name: '',
                                status: '',
                                data: {},
                            });
                        }}
                        extractionId={selectedExtraction.id}
                        batchId={selectedFile.batchId}
                        fileData={selectedFile}
                        extraction={selectedExtraction}
                        initialFileStatus={'All'}
                        uid={userId}
                        allFiles={allFiles}
                        currentIndex={selectedFile.currentIndex}
                    />
                ) : (
                    // Use original ViewFileAdmin for batch view mode
                    <ViewFileAdmin
                        closeModal={() => {
                            setShowFileBool(false);
                            setSelectedFile({
                                file_id: '',
                                file_url: '',
                                file_name: '',
                                status: '',
                                data: {},
                            });
                        }}
                        extractionId={selectedExtraction.id}
                        batchId={selectedBatch.id}
                        fileData={selectedFile}
                        extraction={selectedExtraction}
                        initialFileStatus={'All'}
                        uid={userId}
                    />
                )}
            </ModalForViewFile>

            <nav className="flex mb-5" aria-label="Breadcrumb">
                <ol className="flex space-x-4 rounded-md bg-white px-6 shadow">
                    <li className="flex h-11">
                        <div className="flex items-center">
                            <button
                                onClick={() => changeView('extractions')}
                                className="text-sm font-medium text-gray-500 hover:text-gray-700"
                            >
                                Extractions
                            </button>
                        </div>
                    </li>
                    {(viewType === 'batches' || viewType === 'batch') &&
                        <li className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <button
                                    onClick={() => changeView('batches')}
                                    className={classNames(viewType === 'batches' ? "text-indigo-500 hover:text-indigo-700" : "", "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700")}
                                >
                                    Batches
                                </button>
                            </div>
                        </li>}
                    {viewType === 'batch' &&
                        <li className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <button
                                    onClick={() => changeView('batch')}
                                    className={classNames(viewType === 'batch' ? "text-indigo-500 hover:text-indigo-700" : "", "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700")}
                                >
                                    Batch
                                </button>
                            </div>
                        </li>}
                </ol>
            </nav>

            {viewType === 'extractions' &&
                <div className='w-full'>
                    <ul className="divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
                        {extractionsList.map((extraction) => (
                            <li
                                key={extraction.id}
                                className="cursor-pointer gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6"
                            >
                                <button
                                    onClick={() => changeViewType({
                                        type: 'batches',
                                        extractionId: extraction.id
                                    })}
                                    className='w-full relative flex justify-between'
                                >
                                    <div className="flex min-w-0 gap-x-4">
                                        <div className="min-w-0 flex-auto">
                                            <div className="flex items-start gap-x-3">
                                                <p className="text-sm font-semibold leading-6 text-gray-900">{extraction.name}</p>
                                                <p
                                                    className={classNames(
                                                        statuses[extraction.status],
                                                        'rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset'
                                                    )}
                                                >
                                                    {extraction.status}
                                                </p>
                                            </div>
                                            <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                                                {(extraction.description !== null && extraction.description.length > 0) &&
                                                    <>
                                                        <p className="whitespace-nowrap">
                                                            {extraction.description}
                                                        </p>
                                                        <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                                                            <circle cx={1} cy={1} r={1} />
                                                        </svg>
                                                    </>
                                                }
                                                <p className="truncate">{extraction.noOfBatches} Batches</p>
                                                <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                                                    <circle cx={1} cy={1} r={1} />
                                                </svg>
                                                <p className="truncate">{extraction.noOfFields} Fields</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex shrink-0 items-center gap-x-4">
                                        <ChevronRightIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                                    </div>
                                </button>
                            </li>
                        ))}
                    </ul>

                    {extractionsList.length === 0 &&
                        <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-8">
                            <div className="text-center">
                                <h2 className="text-xl font-semibold text-gray-900">No extractions yet</h2>
                                <p className="mt-1.5 text-sm text-gray-600">
                                    Get started by creating a new extraction.
                                </p>
                            </div>
                        </div>
                    }
                </div>
            }

            {viewType === 'batches' &&
                <div className='w-full'>
                    <div className="">
                        <ExtractionHeading
                            extractionName={selectedExtraction.name}
                            extractionLanguage={selectedExtraction.language}
                            extractionCreatedAt={formatDate(selectedExtraction.createdAt)}
                            extractionBatchCount={selectedExtraction.length}
                            extractionStatus={selectedExtraction.status}
                            extractionFieldsCount={selectedExtraction.fields?.length || 0}
                            extractionFields={selectedExtraction.fields}
                            deleteExtraction={() => selectedExtraction()}
                        />
                    </div>

                    <div className="mt-4 mb-2 flex justify-end">
                        <button
                            onClick={toggleViewMode}
                            className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >
                            {viewMode === 'batches' ? 'View All Files' : 'View Batches'}
                        </button>
                    </div>

                    {viewMode === 'batches' && (
                        <>
                            {/* Batch ID Filter Section */}
                            <div className="mt-4 mb-4 bg-white p-4 rounded-lg shadow-sm ring-1 ring-gray-900/5">
                                <div className="flex items-center gap-2">
                                    <label htmlFor="batch-id-search" className="text-sm font-medium text-gray-700 whitespace-nowrap">
                                        Filter by Batch ID:
                                    </label>
                                    <input
                                        id="batch-id-search"
                                        type="text"
                                        value={batchIdInput}
                                        onChange={(e) => setBatchIdInput(e.target.value)}
                                        onKeyDown={handleBatchIdInputKeyDown}
                                        placeholder="Enter batch ID and press Enter"
                                        className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                    {selectedBatchIds.length > 0 && (
                                        <button
                                            onClick={clearAllBatchIdFilters}
                                            className="inline-flex items-center rounded-md bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200"
                                        >
                                            Clear All
                                        </button>
                                    )}
                                </div>

                                {/* Display selected batch IDs as chips */}
                                {selectedBatchIds.length > 0 && (
                                    <div className="mt-3 flex flex-wrap gap-2">
                                        {selectedBatchIds.map((id) => (
                                            <span
                                                key={id}
                                                className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-100 px-2.5 py-1.5 text-sm font-medium text-indigo-700"
                                            >
                                                {id}
                                                <button
                                                    type="button"
                                                    onClick={() => removeBatchIdFilter(id)}
                                                    className="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none"
                                                >
                                                    <XMarkIcon className="h-3 w-3" aria-hidden="true" />
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div>
                                <PaginationAdmin
                                    numberOfPages={noOfPagesBatch}
                                    currentPageNumber={currentBatchPage}
                                    previousButton={previousBatchPage}
                                    nextButton={nextBatchPage}
                                    selectPage={() => { }}
                                    itemsPerPage={0}
                                    setItemsPerPage={() => { }}
                                />
                            </div>
                        </>
                    )}

                    {viewMode === 'batches' ? (
                        <div className="mt-5 flow-root">
                            {/* Existing batches table */}
                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                        <table className="min-w-full divide-y divide-gray-300">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                        Id
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        No. of documents
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Created at
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Status
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {batchesList.map((batch) => (
                                                    <tr
                                                        key={batch.id}
                                                        className="hover:bg-gray-50 cursor-pointer"
                                                        onClick={() => changeViewType({
                                                            type: 'batch',
                                                            extractionId: selectedExtraction.id,
                                                            batchId: batch.id
                                                        })}
                                                    >
                                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                            {batch.id}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {batch.numberOfDocuments} {batch.numberOfDocuments === 1 ? 'document' : 'documents'}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {formatExtractionsDate(batch.startDateTime)}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            <p
                                                                className={classNames(
                                                                    statuses[batch.status],
                                                                    'rounded-md inline-block mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset'
                                                                )}
                                                            >
                                                                {batch.status}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="mt-5 flow-root">
                            {isLoadingAllFiles ? (
                                <div className="flex justify-center items-center h-40">
                                    <p className="text-gray-500">Loading all files...</p>
                                </div>
                            ) : (
                                <>
                                    {allFiles.length > 0 ? (
                                        <>
                                            {/* Move pagination here, above the table */}
                                            <div className="mb-4">
                                                <PaginationAdmin
                                                    numberOfPages={noOfAllFilesPages}
                                                    currentPageNumber={currentAllFilesPage}
                                                    previousButton={previousAllFilesPage}
                                                    nextButton={nextAllFilesPage}
                                                    selectPage={selectAllFilesPage}
                                                    itemsPerPage={itemsPerAllFilesPage}
                                                    setItemsPerPage={() => { }}
                                                />
                                            </div>

                                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                                        <table className="min-w-full divide-y divide-gray-300">
                                                            <thead className="bg-gray-50">
                                                                <tr>
                                                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                                        File Name
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                        Batch ID
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                        Status
                                                                    </th>
                                                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                                        <span className="sr-only">View</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                                {allFiles
                                                                    .slice(
                                                                        (currentAllFilesPage - 1) * itemsPerAllFilesPage,
                                                                        currentAllFilesPage * itemsPerAllFilesPage
                                                                    )
                                                                    .map((file) => (
                                                                        <tr key={file.id} className="hover:bg-gray-50">
                                                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                {file.name}
                                                                            </td>
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {file.batchId}
                                                                            </td>
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                <span className={`${file.status === 'processed' ? 'text-green-600' :
                                                                                    file.status === 'error' ? 'text-red-600' :
                                                                                        'text-orange-600'
                                                                                    }`}>
                                                                                    {file.status}
                                                                                </span>
                                                                                {file.status === 'error' && file.errorMessage && (
                                                                                    <span className="ml-2 text-red-500">({file.errorMessage})</span>
                                                                                )}
                                                                            </td>
                                                                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                                <button
                                                                                    onClick={() => openFileResult(file)}
                                                                                    className="text-indigo-600 hover:text-indigo-900"
                                                                                >
                                                                                    View<span className="sr-only">, {file.name}</span>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-10">
                                            <p className="text-gray-500">No files found for this extraction.</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            }

            {viewType === 'batch' &&
                <div className='w-full'>
                    <div className="">
                        <BatchHeading
                            batchName={"Batch"}
                            batchCreatedAt={formatExtractionsDate(selectedExtraction?.batches[selectedBatch.id].startTime)}
                            batchUpdatedAt={formatExtractionsDate(selectedExtraction?.batches[selectedBatch.id].startTime)}
                            batchFilesCount={selectedExtraction?.batches[selectedBatch.id].files.length}
                            batchFieldsCount={selectedExtraction?.fields.length}
                            batchOrigin={selectedExtraction?.batches[selectedBatch.id].origin}
                        />
                    </div>

                    <div className="mt-5">
                        <p>Batch id: {selectedBatch.id}</p>
                    </div>

                    <div className="mt-5 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto overflow-y-hidden sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <div className="relative">
                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                                    {"File name".toUpperCase()}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {"Status".toUpperCase()}
                                                </th>
                                                {fields.map((field) => (
                                                    <th key={field.key} scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        {field.key.toUpperCase()}
                                                    </th>
                                                ))}
                                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {files.map((file, index) => (
                                                <tr key={file.id}>
                                                    <td
                                                        className={classNames(
                                                            'whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900',
                                                        )}
                                                    >
                                                        <button onClick={() => openFileResult(file)}>
                                                            <span className='group-hover:underline group-hover:text-indigo-600 mr-1.5 cursor-pointer'>
                                                                {file.name}
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td key={index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        <span className='text-red-300'>
                                                            {file.status === 'error' ? 'error' : ''}
                                                            {file.status === 'error' ? (
                                                                file.errorMessage !== undefined ? (': ' + file.errorMessage) : ''
                                                            ) : ''}
                                                        </span>
                                                        <span className='text-orange-300'>
                                                            {file.status === 'waiting' ? 'processing' : ''}
                                                        </span>
                                                        <span className=''>
                                                            {file.status === 'processed' ? 'done' : ''}
                                                        </span>
                                                    </td>
                                                    {fields.map((field, index) => {
                                                        const value = file.result[field.key];
                                                        let displayValue;
                                                        let titleValue = ''; // Used for hover tooltip
                                                        let type = '';

                                                        if (typeof value === 'string') {
                                                            displayValue = value.length > maxCharactersForField ? value.slice(0, maxCharactersForField) + '...' : value;
                                                            titleValue = value.length > maxCharactersForField ? value : '';
                                                            type = 'string';
                                                        } else if (value) {
                                                            // Convert object or list to string
                                                            const stringValue = JSON.stringify(value);
                                                            displayValue = stringValue.length > maxCharactersForFieldObject ? stringValue.slice(0, maxCharactersForFieldObject) + '...' : stringValue;
                                                            titleValue = stringValue.length > maxCharactersForFieldObject ? stringValue : '';
                                                            type = 'object';
                                                        } else {
                                                            displayValue = '-';
                                                        }

                                                        if (type === 'object') {
                                                            return (
                                                                <td key={index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                    <div className='flex flex-row'>
                                                                        <div className="truncate" title={titleValue}>
                                                                            {displayValue}
                                                                        </div>
                                                                        <JsonViewerWindow key={index} jsonData={value} />
                                                                    </div>
                                                                </td>
                                                            );
                                                        } else {
                                                            return (
                                                                <td key={index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                    <div className="truncate" title={titleValue}>
                                                                        {displayValue}
                                                                    </div>
                                                                </td>
                                                            );
                                                        }
                                                    })}
                                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3 relative">
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-20'></div>
                </div>
            }
        </div>
    )
}

function ExtractionHeading({
    extractionName,
    extractionLanguage,
    extractionCreatedAt,
    extractionBatchCount,
    extractionStatus,
    extractionFieldsCount,
    extractionFields,
    editExtraction,
    deleteExtraction,
}) {
    return (
        <div className="lg:flex lg:items-center lg:justify-between">
            <div className="min-w-0 flex-1">
                <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                    {extractionName}
                </h2>
                <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <GlobeAltIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {extractionLanguage}
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <CubeIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {extractionBatchCount} Batche(s)
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <AdjustmentsHorizontalIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {extractionFieldsCount} Field(s)
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <CalendarIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {extractionCreatedAt}
                    </div>
                </div>
                <div>
                    {extractionFields.map((field) => (
                        <div key={field.key} className="mt-2 flex items-center text-sm text-gray-500">
                            <div className="mt-2 flex items-center text-sm text-gray-500">
                                <AdjustmentsHorizontalIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                {field.key}, '{field.type ?? '-no type-'}', '{field.description ?? '-no description-'}', '{field.example ?? '-no example-'}'
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function BatchHeading({
    batchName,
    batchCreatedAt,
    batchUpdatedAt,
    batchFilesCount,
    batchFieldsCount,
    batchOrigin,
    deleteBatch,
}) {
    const originIcon = (batchOrigin) => {
        switch (batchOrigin) {
            case 'web':
                return <GlobeAltIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />;
            case 'api':
                return <CodeBracketIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />;
            default:
                return null; // Return null or a default icon if needed
        }
    };

    return (
        <div className="lg:flex lg:items-center lg:justify-between">
            <div className="min-w-0 flex-1">
                <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                    {batchName}
                </h2>
                <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <DocumentTextIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {batchFilesCount} File(s)
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <AdjustmentsHorizontalIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        {batchFieldsCount} Field(s)
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        {originIcon(batchOrigin)} {/* Displaying the origin icon */}
                        Origin: {batchOrigin}
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                        <CalendarIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                        Created: {batchCreatedAt}
                    </div>
                    {/* <div className="mt-2 flex items-center text-sm text-gray-500">
              <CalendarIcon className="mr-1.5 h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
              Updated: {batchUpdatedAt}
            </div> */}
                </div>
            </div>
            {/* <div className="mt-5 flex lg:ml-4 lg:mt-0">
            <span className="ml-3">
              <button
                onClick={() => deleteBatch()}
                type="button"
                className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                <TrashIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                Delete Batch
              </button>
            </span>
          </div> */}
        </div>
    );
}

function JsonViewerWindow({ jsonData }) {
    // State to control the visibility of the modal
    const [isModalOpen, setModalOpen] = useState(false);

    // Function to handle outside click
    const handleOutsideClick = (e) => {
        if (e.target === e.currentTarget) {
            setModalOpen(false);
        }
    };

    const jsonViewerStyle = {
        maxHeight: '80vh', // Maximum height of the container
        overflowY: 'auto', // Enable vertical scrolling
        wordBreak: 'break-all', // Breaks long words to prevent overflow
    };

    return (
        <div className="">
            {/* Button with only icon, small, to trigger the modal */}
            <button
                onClick={() => setModalOpen(true)}
                className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-gray-100 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <FontAwesomeIcon icon={faCode} />
            </button>

            {/* Modal content */}
            {isModalOpen && (
                <div
                    onClick={handleOutsideClick}
                    className="fixed inset-0 flex items-center justify-center z-50 shadow-xl"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="bg-white rounded-lg w-1/3 p-6 shadow-xl relative"
                        style={jsonViewerStyle}
                    >
                        {/* Close icon */}
                        <span
                            onClick={() => setModalOpen(false)}
                            className="absolute top-4 right-4 cursor-pointer text-xl font-bold hover:text-gray-600"
                        >
                            &times;
                        </span>
                        {/* <JsonView
                src={jsonData}
                enableClipboard={false}
                displayDataTypes={false}
                displayObjectSize={false}
              /> */}
                        <ReactJson
                            src={jsonData}
                            theme="vscode"
                            enableClipboard={false}
                            displayDataTypes={false}
                            displayObjectSize={false}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}